import { Component, OnInit, HostBinding, Output, EventEmitter, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../field.interface';
import {fadeIn} from "../../../animations/basic-animation";
@Component({
  selector: 'app-button',
  template: `
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 pt-4">
          <div class="col-sm-12" [formGroup]="group">
            <app-save-area
              [showCancel]="showCancel"
              [cancelText]="cancelText"
              [hideSave]="hideSave"
              [saveText]="field?.label || saveText"
              [savingData]="loading"
              [saveDisabled]="group?.invalid"
              [confirmFirst]="confirmFirst"
              [confirmText]="confirmMessage"
              [loadingMessage]="loadingMessage"
              (cancel)="closeForm()"
              [isSubmit]="true"
            ></app-save-area>
          </div>
          <!--      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>-->
        </div>
        <!--    <div class="col-sm-12 p-0" style="text-align: right;" *ngIf="!loading" @fadeIn [formGroup]="group">-->
        <!--      <button @fadeIn type="submit"  class="fa-pull-right" [disabled] = "group?.invalid"-->
        <!--        mat-raised-button color="primary">{{field?.label}}</button>-->
        <!--        <button type="button" @fadeIn *ngIf="field?.showCancel" class="fa-pull-right" mat-button color="warn"-->
        <!--        (click)="closeForm()">Cancel</button>-->
        <!--    </div>-->
      </div>

    </div>

  `,

  styles: [],
  animations: [fadeIn]
})
export class ButtonComponent implements OnInit {
  @Input() field?: FieldConfig;
  @Input() group: UntypedFormGroup = new UntypedFormGroup({});
  @Input() loading = false;
  @Input() showCancel = false;
  @Input() loadingMessage = 'Please Wait, Loading ...';
  @Input() confirmFirst = false;
  @Input() hideSave = false;
  @Input() confirmMessage = '';
  @Input() cancelText = 'Cancel';
  @Input() saveText = 'Submit';
  @Output() cancelForm = new EventEmitter();
  constructor() {}

  ngOnInit() {

  }
  closeForm() {
    this.cancelForm.emit();
  }
}
